import Vue from 'vue'
import VueRouter from 'vue-router'
import Opening from './components/Opening.vue'
import Intro from './components/Intro.vue'
import PerennialMap from './components/PerennialMap.vue'
import AllStops from './components/AllStops.vue'
import Pano from './components/Pano.vue'
import Exhibit from './components/Exhibit.vue'
import Container from './components/container.js'
import Photos from './components/Photos.vue'
import Videos from './components/Videos.vue'
import Audio from './components/Audio.vue'
import Letters from './components/Letters.vue'
import Text from './components/Text.vue'
import Seasons from './components/Seasons.vue'
import AllMedia from './components/AllMedia.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', component: Opening },
  { path: '/intro', component: Intro },
  { path: '/intro/:carouselIndex', component: Intro, props: true },
  { path: '/allstops', component: AllStops },
  { path: '/map', component: PerennialMap },
  {
    path: '/exhibit/:exhibitslug',
    component: Container,
    props: (route) => ({ exhibitslug: route.params.exhibitslug, 'container_class': 'exhibit-container' }),
    children: [
      { path: 'seasons', component: Seasons, props: true },
      { path: 'allmedia', component: AllMedia, props: true },
      { path: 'pano', component: Pano, props: true },
      { path: 'photos/:gid/:slide?', component: Photos, props: (route) => ({ exhibitslug: route.params.exhibitslug, 'gid': !isNaN(parseInt(route.params.gid)) ? parseInt(route.params.gid) : 0, 'slide': !isNaN(parseInt(route.params.slide)) ? parseInt(route.params.slide) : 0 }) },
      { path: 'videos/:video?', name: 'video', component: Videos, props: (route) => ({ exhibitslug: route.params.exhibitslug, 'video': !isNaN(parseInt(route.params.video)) ? parseInt(route.params.video) : 0 }) },
      { path: 'audio/:audio?', name: 'audio', component: Audio, props: (route) => ({ exhibitslug: route.params.exhibitslug, 'audio': !isNaN(parseInt(route.params.audio)) ? parseInt(route.params.audio) : 0 }) },
      { path: 'letters/:letter?', name: 'letters', component: Letters, props: (route) => ({ exhibitslug: route.params.exhibitslug, 'letter': !isNaN(parseInt(route.params.letter)) ? parseInt(route.params.letter) : 0 }) },
      { path: '', name: 'exhibit', component: Exhibit, props: true }
    ]
  },
  {
    path: '/help',
    component: Text,
    props: {
      showhelp: false,
      title: 'PERENNIAL GARDEN',
      text: '<p><strong>Interactive Mobile Guide</strong></p><p>The Jane Watson Irwin Perennial Garden is a welcoming, beautiful oasis throughout the year. Located beside the landmark Enid A. Haupt Conservatory, it is a prime location to explore on each visit to NYBG</p><p>In  this  guide  you  can  explore  each  of  the  garden’s  themed  &ldquo;rooms&rdquo;  throughout  the  seasons.</p><ul><li>View 360-degree morphing experiences of different seasons throughout the Perennial Garden</li><li>Explore  slideshows  featuring  distinctive  plants  selected  for  color  and  seasonality</li><li>Dig  deeper  with  snapshots of  seasonal  highlights</li><li>View  videos  with  NYBG  curators  and  experts</li></ul><p>Tips for using this guide:</p><ul><li>Please be sure to enable location services in your device settings.</li><li>For the best experience, connect to NYBG Guest WiFi.</li><li>Click on points on the maps throughout to find out more and access content.</li></ul>'
    }
  }
]

export const router = new VueRouter({
  mode: 'hash',
  routes
})
